'use client';

import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { LANGS, LANG_LABELS } from '../lib/langs';
import type { Lang } from '../lib/langs';

export type { Lang };
export { LANGS, LANG_LABELS };

export function detectLang(): Lang {
  if (typeof window === 'undefined') return 'ja';
  const stored = localStorage.getItem('la-studio-lang') as Lang | null;
  if (stored && LANGS.includes(stored)) return stored;
  const browserLang = navigator.language.split('-')[0].toLowerCase();
  if (LANGS.includes(browserLang as Lang)) return browserLang as Lang;
  return 'en';
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  return { lang: ctx.lang, setLang: ctx.setLang, localizedPath: ctx.localizedPath, LANGS, LANG_LABELS };
}
